import { Alert, Button, Card } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../../context/page-context';

export function RecoveryCodesCard({ codes }: { codes: string[] }) {
  const { notificationHandler } = useHandlers();

  async function copyAll() {
    try {
      await navigator.clipboard.writeText(codes.join('\n'));
      notificationHandler.notify(t('notifications:copied'), undefined, 'success');
    } catch {
      notificationHandler.error();
    }
  }

  return (
    <Card>
      <Card.Header headingLevel="h3">
        {t('features:account.components.recovery_codes_card.title')}
      </Card.Header>
      <Card.Body>
        <div className="flex flex-col gap-4">
          <Alert headingLevel="span" variant="warning">
            {t('features:account.components.recovery_codes_card.description')}
          </Alert>
          <div className="grid grid-cols-2 gap-2 rounded-lg bg-gray-50 p-4 font-mono text-sm">
            {codes.map((code) => (
              <span key={code}>{code}</span>
            ))}
          </div>
          <div>
            <Button variant="secondary" icon="copy" onClick={copyAll}>
              {t('features:account.components.recovery_codes_card.copy_all')}
            </Button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
